module.exports = __webpack_public_path__ + "static/media/ball_1_5.c87944d1.mp3";